import { render, staticRenderFns } from "./EquipmentSpecifications.vue?vue&type=template&id=52bda03e"
import script from "./EquipmentSpecifications.vue?vue&type=script&lang=js"
export * from "./EquipmentSpecifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports